import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { DrillingSession } from 'src/app/shared/models/drilling.models';

@Component({
  selector: 'drill-kpi-summary',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatProgressBarModule, DecimalPipe],
  templateUrl: './drill-kpi-summary.component.html',
  styleUrls: ['./drill-kpi-summary.component.scss'],
})
export class DrillKpiSummaryComponent {
  readonly sessions = input.required<DrillingSession[]>();
  readonly targetMeters = input.required<number>();

  protected readonly totalDrilled = computed(() =>
    this.sessions().reduce((sum, s) => sum + s.drilledMeters, 0),
  );

  protected readonly totalEngineHours = computed(() =>
    this.sessions().reduce((sum, s) => sum + s.engineHours, 0),
  );

  protected readonly progressPercent = computed(() => {
    const target = this.targetMeters();
    if (target <= 0) return 0;
    return Math.min(100, (this.totalDrilled() / target) * 100);
  });

  protected readonly isComplete = computed(() => this.progressPercent() >= 100);

  protected readonly drillingRate = computed(() => {
    const hours = this.totalEngineHours();
    if (hours <= 0) return 0;
    return this.totalDrilled() / hours;
  });
}
